var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgRenewal = function SvgRenewal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.573 2.404C6.574-.04 10.864.133 13.68 2.616V1.063h1.062v3.453H11.29V3.453h1.727c-2.43-2.178-6.163-2.337-8.78-.212a6.729 6.729 0 00-2.204 7.291l-1.01.319a7.8 7.8 0 012.55-8.447zm4.303 12.83a6.712 6.712 0 004.887-1.475c2.192-1.766 3.042-4.648 2.192-7.357l1.01-.32a7.78 7.78 0 01-2.538 8.488 7.728 7.728 0 01-4.914 1.753c-.239 0-.478-.014-.73-.04a7.764 7.764 0 01-4.33-1.807v1.581H2.391v-3.453h3.453v1.062H4.13a6.763 6.763 0 003.746 1.567z"
  })));
};

export default SvgRenewal;